/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminPlanGet = {
  id: 'admin-plan.get',
  tag: 'Admin',
  summary: 'Plan administration',
  description: 'Get all Products',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/plan`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            computePlans: z.optional(
              z.array(
                // ComputePlan
                z.strictObject({
                  id: ZodTypes.Id,
                  name: z.string().min(1),
                  serviceType: ZodTypes.ServiceType,
                  cpu: z.number().min(0),
                  memory: z.number().min(0),
                  replicaMin: z.number().min(0),
                  replicaMax: z.number().min(0),
                  replicaDefault: z.number().min(0),
                  isDefault: z.boolean(),
                  isVisible: z.boolean(),
                }),
              ),
            ),
            storagePlans: z.optional(
              z.array(
                // Storage Plan
                z.strictObject({
                  id: ZodTypes.Id,
                  name: z.string().min(1),
                  serviceType: ZodTypes.ServiceType,
                  size: z.number().min(0),
                  isDefault: z.boolean(),
                  isVisible: z.boolean(),
                  storageClass: z.strictObject({
                    id: z.string(),
                    isDefault: z.boolean(),
                  }),
                }),
              ),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
